// Tracking rows are keyed by the athlete's own calendar day. `toISOString()`
// gives the UTC date, which in Colombia (UTC-5) is already tomorrow from 7 pm,
// so dinner used to land on the next day's row.

const pad = (value) => String(value).padStart(2, "0");

/** Device-local YYYY-MM-DD for `date` (default: now). */
export const localDateKey = (date = new Date()) =>
  `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

const MONTHS = [
  "enero",
  "febrero",
  "marzo",
  "abril",
  "mayo",
  "junio",
  "julio",
  "agosto",
  "septiembre",
  "octubre",
  "noviembre",
  "diciembre",
];

/** "2026-09-12" → "12 de septiembre". Returns "" for anything else. */
export const formatDateKey = (key) => {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(key || "");
  if (!match) return "";
  const month = MONTHS[Number(match[2]) - 1];
  return month ? `${Number(match[3])} de ${month}` : "";
};
